import React, { memo } from 'react';
import { AdvancedImage, responsive } from '@cloudinary/react';
import { QualityTypes } from '@cloudinary/url-gen/types/types';
import { CloudinaryImage } from '@cloudinary/url-gen';
import styled from '@emotion/styled';
import { borderRadius } from '@naf/theme';
import { useCloudinary } from '../../hooks/Cloudinary/useCloudinary';

type Props = {
  altText: string;
  quality?: QualityTypes;
  className?: string;
  image?: CloudinaryImage;
  imageId?: string;
  aspectRatio?: string;
};

const ResponsiveImage = memo(({ imageId, image, quality, altText, className, aspectRatio }: Props) => {
  const { getResponsiveImage } = useCloudinary();
  const cldImage = getResponsiveImage(imageId, { quality, width: 1400, aspectRatio });
  const displayedImage = image || cldImage;
  if (!displayedImage) return null;
  return (
    <StyledAdvancedImage
      cldImg={displayedImage}
      plugins={[responsive({ steps: 200 })]}
      alt={altText}
      className={className}
    />
  );
});

export default ResponsiveImage;

const StyledAdvancedImage = styled(AdvancedImage)`
  width: 100%;
  border-radius: ${borderRadius.S};
`;
